import { Translations } from '@domain/admission';

const TRANSLATION_ORDER = ['en', 'es', 'it', 'fr', 'pt', 'de', 'ca'];

export const getTranslatedPropertyBasedOnOrder = ({
  translations,
  preferredLanguage,
}: {
  translations: Translations;
  preferredLanguage: string;
}) => {
  const language = preferredLanguage as keyof Translations;

  if (translations[language]) {
    return translations[language];
  }

  let translatedProperty = null;

  for (let i = 0; i < TRANSLATION_ORDER.length; i++) {
    const currentTranslationOrder = TRANSLATION_ORDER[i];
    // eslint-disable-next-line
    // @ts-ignore
    const currentTranslatedProperty = translations[currentTranslationOrder];

    if (currentTranslatedProperty) {
      translatedProperty = currentTranslatedProperty;
      break;
    }
  }

  return translatedProperty;
};
